import type { V2AgentRef } from "@/context/MissionControlWebSocketContext";
import {
  mergeNullableTextField,
  mergeTaskAgentRef,
  mergeTaskEntityRef,
} from "@/components/missions/entityRefs";
import type { TaskActionItem, TaskAgentRef } from "../types";

/** Map top-level WS agent ref onto the task row shape. */
export function v2AgentRefToTaskAgentRef(
  agent: V2AgentRef | null | undefined,
): TaskAgentRef | null {
  if (!agent?.id) return null;
  const name = agent.name?.trim();
  return {
    id: agent.id,
    name: name || "Agent",
    role: agent.role ?? null,
  };
}

/** Merge a WS task row onto a cached list row without wiping hydrated fields. */
export function mergeTaskActionItemPatch(
  previous: TaskActionItem,
  incoming: TaskActionItem,
  fallbackAgent?: TaskAgentRef | null,
): TaskActionItem {
  let agent = mergeTaskAgentRef(previous.agent, incoming.agent);
  if (!agent && fallbackAgent) {
    agent = mergeTaskAgentRef(null, fallbackAgent);
  }
  return {
    ...previous,
    ...incoming,
    entity: mergeTaskEntityRef(previous.entity, incoming.entity),
    agent,
    definition_of_done: mergeNullableTextField(
      previous.definition_of_done,
      incoming.definition_of_done,
    ),
    latest_summary: mergeNullableTextField(previous.latest_summary, incoming.latest_summary),
  };
}
